import { useTranslation } from "react-i18next";

import { IModal } from "../../types/modal";
import { CustomButton, IButtonVariant } from "../CustomButton";
import { CustomModal } from "../CustomModal";

import styles from "./ConfirmModal.module.scss";

type ConfirmationModalProps = IModal & {
  title: string;
  text: string;
  confirmText?: string;
  cancelText?: string;
  isConfirming?: boolean;
  onSuccess?: () => void;
  onCancel?: () => void;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isModalVisible,
  toggleModalVisibility,
  onSuccess,
  onCancel,
  title,
  text,
  confirmText,
  cancelText,
  isConfirming,
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    toggleModalVisibility();
    if (onSuccess) onSuccess();
  };

  const handleCancel = () => {
    toggleModalVisibility();
    if (onCancel) onCancel();
  };

  return (
    <CustomModal
      isModalVisible={isModalVisible}
      toggleModalVisibility={toggleModalVisibility}
      title={title}
      text={text}
    >
      <div className={styles.formContainer}>
        <CustomButton
          text={cancelText ?? t("confirmModal.cancel")}
          onClick={handleCancel}
          variant={IButtonVariant.neutral}
          disabled={isConfirming}
        />
        <CustomButton
          text={confirmText ?? t("confirmModal.confirm")}
          onClick={handleConfirm}
          variant={IButtonVariant.primary}
          disabled={isConfirming}
        />
      </div>
    </CustomModal>
  );
};
